import type {Field007Code, Field007Definitions, Field007DocumentCategory, Field007Label} from 'typings/portaro.be.types';
import {ValueEditorFieldBuilder} from '../utils/value-editor-field-builder';
import {Field7CodeConverter} from '../utils/field7-code-converter';
import type {Field7Model} from '../utils/types';
import {getCodesByPosition, optionsComparator} from '../utils/utils';
import {ascendingOrderComparator} from 'shared/utils/array-utils.fp';
import type {ILogService} from 'angular';
import type { KpUniversalFormSettings } from 'src/commons/value-editors/kp-universal-form/types';
import type {ObjectValueEditorField} from '../../../commons/value-editors/meta-editors/object/types';
import CodeAndDescriptionAcceptableEditorLabel from '../utils/CodeAndDescriptionAcceptableEditorLabel.svelte';
import type {SvelteComponentConstructor} from '../../../svelte/types';


export class Field7EditorService {
    private readonly codeConverter: Field7CodeConverter;
    private readonly fieldBuilder: ValueEditorFieldBuilder;

    constructor(private definitions: Field007Definitions, $log: ILogService) {
        this.codeConverter = new Field7CodeConverter(definitions, $log);
        this.fieldBuilder = new ValueEditorFieldBuilder();
    }

    public serializeModel(model: Field7Model) {
        return this.codeConverter.serializeModel(model);
    }

    public parseCode(value: string): Field7Model | null {
        return this.codeConverter.parseCode(value);
    }

    public initializeFormsFirstSegment(filteredDocumentCategoriesOptions: Field007DocumentCategory[]): KpUniversalFormSettings<Field7Model, ObjectValueEditorField<Field7Model>[]> {
        this.fieldBuilder
            .withLabel('00 Kategorie dokumentu')
            .withFieldName('documentCategory')
            .withSingleAcceptableEditor(CodeAndDescriptionAcceptableEditorLabel as SvelteComponentConstructor<{option: any}>, {required: true})
            .asInline(false)
            .withAcceptableValues(filteredDocumentCategoriesOptions);

        return {fields: [this.fieldBuilder.build()]};
    }

    // impure function - mutates formModel
    public setPositionsDefaultValueToModel(formModel: Field7Model, positionOrder: number, codes: Field007Code[]) {
        formModel[`position${positionOrder}`] = codes.find((code) => code.isDefaultValue);
    }

    public initializeFormsSecondSegment(formSettings: KpUniversalFormSettings<Field7Model, ObjectValueEditorField<Field7Model>[]>, labels: Field007Label[], codes: Field007Code[]): KpUniversalFormSettings<Field7Model, ObjectValueEditorField<Field7Model>[]> {

        const otherFields = labels
            .sort(ascendingOrderComparator)
            .map((label) => this.createEditorField(label, getCodesByPosition(codes, label.order)));

        return {fields: [formSettings.fields[0], ...otherFields]};
    }

    private createEditorField(label: Field007Label, options: Field007Code[]): ObjectValueEditorField<Field7Model> {
        return this.fieldBuilder
            .withLabel(label.description)
            .withFieldName(`position${label.order}`)
            .withSingleAcceptableEditor(CodeAndDescriptionAcceptableEditorLabel as SvelteComponentConstructor<{option: any}>, {required: true})
            .asInline(true)
            .withAcceptableValues(options.sort(optionsComparator))
            .build();
    }
}